import { COMMENT_MAX_LENGTH, COMMENT_MIN_LENGTH } from '../constants/comments';
import { IComments, TComment } from '../interfaces/comments';

import { moscowDateToUTCDate } from './moscowDateToUTCDate';

export const validate = (text: string): { error: boolean; errorMessage: string } => {
  let validationState = {
    error: false,
    errorMessage: '',
  };

  const textWithoutSpaces = text.replace(/\r\n|\r|\n|\s|\u200B/g, '');
  const repeatedCharsRegExp = /([^a-zа-я0-9])\1{3,}/g;
  const hasRepeatedChars = textWithoutSpaces.toLowerCase().match(repeatedCharsRegExp);

  if (textWithoutSpaces.length < COMMENT_MIN_LENGTH) {
    validationState.errorMessage = 'Слишком короткий комментарий';
  }

  if (textWithoutSpaces.length > COMMENT_MAX_LENGTH) {
    validationState.errorMessage = 'Слишком длинный комментарий';
  }

  if (hasRepeatedChars) {
    validationState.errorMessage = 'Не должно быть одинаковых символов, повторяющихся более 3 раз';
  }

  if (validationState.errorMessage) {
    validationState.error = true;
  }

  return validationState;
};

export const decorateComment = (item: TComment) => {
  const clearItem = {
    ...item,
    created: moscowDateToUTCDate(item.created),
  };

  delete clearItem.email;
  delete clearItem.phone;
  return clearItem;
};

export const decorateCommentsList = (list: IComments) => {
  return {
    ...list,
    items: list.items?.map((item) => decorateComment(item)),
  };
};

const timeTempCreateInputFixIOS = (el: HTMLElement, timeout) => {
  const isIOS = /iPhone|iPad/i.test(navigator.userAgent);

  if (isIOS) {
    let __tempEl__ = document.createElement('input');
    __tempEl__.style.position = 'absolute';
    __tempEl__.style.top = el.offsetTop + 7 + 'px';
    __tempEl__.style.left = el.offsetLeft + 'px';
    __tempEl__.style.height = '0';
    __tempEl__.style.opacity = '0';
    // Поместите этот временный элемент как дочерний элемент страницы <body> и сфокусируйтесь на нем
    document.body.appendChild(__tempEl__);
    __tempEl__.focus();

    // Клавиатура открыта. Теперь делаем отложенный фокус на целевом элементе
    setTimeout(() => {
      el.focus();
      el.click();
      // Удалить временный элемент
      document.body.removeChild(__tempEl__);
    }, timeout);
  } else {
    setTimeout(() => {
      el.focus();
    }, timeout);
  }
};

export const focusAndOpenKeyboardFixIOS = (el: HTMLElement, timeout = 100) => {
  el && timeTempCreateInputFixIOS(el, timeout);

  const handleMutation: MutationCallback = (mutationList: MutationRecord[], observer: MutationObserver) => {
    for (const mutation of mutationList) {
      for (const node of mutation.addedNodes) {
        if (node.parentElement) {
          const textarea = node.parentElement.querySelector('textarea');

          if (textarea) {
            timeTempCreateInputFixIOS(textarea, timeout);
          }
        } else {
          timeTempCreateInputFixIOS(el, timeout);
        }
      }
    }
    observer.disconnect();
  };

  const observer = new MutationObserver(handleMutation);

  observer.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true,
  });
};
